import React from "react";
import { useTranslation } from "react-i18next";
import "./fullyInteractive.scss";

function FullyInteractive() {
   const {t} = useTranslation()

  return (
    <div className="container-fully-interactive">
      <div className="texts-fully-interactive">
        <h1>{t("interactive_dashboards.fully_interactive.title")}</h1>
        <p>{t("interactive_dashboards.fully_interactive.section_text_1")}</p>
        <p>{t("interactive_dashboards.fully_interactive.section_text_2")}</p>
      </div>
    </div>
  );
}

export default FullyInteractive;
